(function () {
  'use strict';

  // =============================================
  // DATA TABLES
  // =============================================

  var SIZE_CHART = [
    { size: 'XXS', waistMin: 22, waistMax: 28, hipMin: 28, hipMax: 34 },
    { size: 'XS',  waistMin: 29, waistMax: 34, hipMin: 35, hipMax: 38 },
    { size: 'S',   waistMin: 35, waistMax: 38, hipMin: 39, hipMax: 44 },
    { size: 'M',   waistMin: 39, waistMax: 42, hipMin: 45, hipMax: 48 },
    { size: 'L',   waistMin: 43, waistMax: 46, hipMin: 49, hipMax: 53 },
    { size: 'XL',  waistMin: 47, waistMax: 54, hipMin: 54, hipMax: 58 },
    { size: '2XL', waistMin: 55, waistMax: 58, hipMin: 59, hipMax: 64 },
    { size: '3XL', waistMin: 59, waistMax: 63, hipMin: 65, hipMax: 70 }
  ];

  var HEIGHT_MAP = {
    'under5':      { length: 34, label: 'Extra Short', collection: '/collections/extra-short-34-saree-silhouettes' },
    '5-0-to-5-3':  { length: 36, label: 'Short',       collection: '/collections/short-36-saree-silhouettes' },
    '5-3-to-5-7':  { length: 38, label: 'Regular',     collection: '/collections/38-saree-silhouettes' },
    '5-7-to-5-8':  { length: 40, label: 'Tall',        collection: '/collections/tall-40-saree-silhouettes' },
    'over5-8':     { length: 42, label: 'Extra Tall',   collection: '/collections/extra-tall-42-saree-silhouette' }
  };

  var CM_TO_IN = 0.393701;

  // =============================================
  // STATE
  // =============================================

  var state = {
    currentStep: 1,
    heightKey: null,
    unit: 'in',
    waist: null,
    hip: null
  };

  // =============================================
  // DOM REFERENCES
  // =============================================

  var quiz, steps, progressSteps, progressLabel, resultEl;
  var waistInput, hipInput, unitBtns, unitDisplays, nextBtn, validationEl;

  // =============================================
  // INITIALIZATION
  // =============================================

  function init() {
    quiz = document.querySelector('.size-quiz');
    if (!quiz) return;

    steps = quiz.querySelectorAll('.size-quiz__step');
    progressSteps = quiz.querySelectorAll('.size-quiz__progress-step');
    progressLabel = quiz.querySelector('.size-quiz__progress-label');
    resultEl = quiz.querySelector('.size-quiz__result');

    waistInput = quiz.querySelector('#quiz-waist');
    hipInput = quiz.querySelector('#quiz-hip');
    unitBtns = quiz.querySelectorAll('.size-quiz__unit-btn');
    unitDisplays = quiz.querySelectorAll('.size-quiz__input-unit');
    nextBtn = quiz.querySelector('.size-quiz__next');
    validationEl = quiz.querySelector('.size-quiz__validation');

    // Step 1: height option clicks
    quiz.querySelectorAll('[data-step="1"] .size-quiz__option').forEach(function (opt) {
      opt.addEventListener('click', handleHeightSelect);
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleHeightSelect.call(this, e);
        }
      });
    });

    // Unit toggle
    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', handleUnitToggle);
    });

    // Measurement inputs
    if (waistInput) waistInput.addEventListener('input', validateInputs);
    if (hipInput) hipInput.addEventListener('input', validateInputs);

    // Next button
    if (nextBtn) nextBtn.addEventListener('click', handleNext);

    // Back buttons
    quiz.querySelectorAll('.size-quiz__back').forEach(function (btn) {
      btn.addEventListener('click', goBack);
    });

    // Retake
    var retakeBtn = quiz.querySelector('.size-quiz__retake');
    if (retakeBtn) retakeBtn.addEventListener('click', retake);
  }

  // =============================================
  // STEP 1: HEIGHT SELECTION
  // =============================================

  function handleHeightSelect(e) {
    var option = e.currentTarget;
    var step = option.closest('.size-quiz__step');

    step.querySelectorAll('.size-quiz__option').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    option.classList.add('is-selected');

    state.heightKey = option.dataset.value;

    setTimeout(function () {
      goToStep(2);
    }, 250);
  }

  // =============================================
  // STEP 2: MEASUREMENT INPUT
  // =============================================

  function handleUnitToggle(e) {
    var newUnit = e.currentTarget.dataset.unit;
    if (newUnit === state.unit) return;

    var waistVal = parseFloat(waistInput.value);
    var hipVal = parseFloat(hipInput.value);

    if (newUnit === 'cm' && state.unit === 'in') {
      if (!isNaN(waistVal)) waistInput.value = Math.round(waistVal / CM_TO_IN * 10) / 10;
      if (!isNaN(hipVal)) hipInput.value = Math.round(hipVal / CM_TO_IN * 10) / 10;
    } else if (newUnit === 'in' && state.unit === 'cm') {
      if (!isNaN(waistVal)) waistInput.value = Math.round(waistVal * CM_TO_IN * 10) / 10;
      if (!isNaN(hipVal)) hipInput.value = Math.round(hipVal * CM_TO_IN * 10) / 10;
    }

    state.unit = newUnit;

    unitBtns.forEach(function (btn) {
      var isActive = btn.dataset.unit === newUnit;
      btn.classList.toggle('is-active', isActive);
    });
    unitDisplays.forEach(function (span) {
      span.textContent = newUnit;
    });

    if (newUnit === 'cm') {
      waistInput.placeholder = 'e.g. 81';
      hipInput.placeholder = 'e.g. 97';
    } else {
      waistInput.placeholder = 'e.g. 32';
      hipInput.placeholder = 'e.g. 38';
    }

    validateInputs();
  }

  function validateInputs() {
    var waistVal = parseFloat(waistInput.value);
    var hipVal = parseFloat(hipInput.value);
    var valid = !isNaN(waistVal) && waistVal > 0 && !isNaN(hipVal) && hipVal > 0;

    nextBtn.disabled = !valid;

    if (valid && validationEl) {
      validationEl.textContent = '';
      validationEl.style.display = 'none';
    }

    return valid;
  }

  function handleNext() {
    if (!validateInputs()) return;

    var waistVal = parseFloat(waistInput.value);
    var hipVal = parseFloat(hipInput.value);

    if (state.unit === 'cm') {
      state.waist = Math.round(waistVal * CM_TO_IN * 10) / 10;
      state.hip = Math.round(hipVal * CM_TO_IN * 10) / 10;
    } else {
      state.waist = waistVal;
      state.hip = hipVal;
    }

    if (state.waist < 20 || state.waist > 70) {
      showValidation('Please enter a waist measurement between 20" and 70" (51 cm – 178 cm).');
      return;
    }
    if (state.hip < 25 || state.hip > 75) {
      showValidation('Please enter a hip measurement between 25" and 75" (64 cm – 191 cm).');
      return;
    }

    showResult();
  }

  function showValidation(msg) {
    if (!validationEl) return;
    validationEl.textContent = msg;
    validationEl.style.display = 'block';
  }

  // =============================================
  // SIZE COMPUTATION
  // =============================================

  /** Find the index of the size whose range contains the measurement */
  function findSizeIndex(measurement, type) {
    var minKey = type + 'Min';
    var maxKey = type + 'Max';

    for (var i = 0; i < SIZE_CHART.length; i++) {
      if (measurement >= SIZE_CHART[i][minKey] && measurement <= SIZE_CHART[i][maxKey]) {
        return i;
      }
    }

    // Fallback: find closest size
    var bestIdx = 0;
    var bestDist = Infinity;
    for (var j = 0; j < SIZE_CHART.length; j++) {
      var dist = Math.max(0, SIZE_CHART[j][minKey] - measurement, measurement - SIZE_CHART[j][maxKey]);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = j;
      }
    }
    return bestIdx;
  }

  function computeSize(waistInches, hipInches) {
    var waistIdx = findSizeIndex(waistInches, 'waist');
    var hipIdx = findSizeIndex(hipInches, 'hip');
    var diff = waistIdx - hipIdx; // positive = waist is larger size, negative = hip is larger size

    // Case 1: Same size
    if (diff === 0) {
      return {
        size: SIZE_CHART[waistIdx].size,
        confidence: 'high',
        note: null,
        betweenSizes: false
      };
    }

    // Case 2: Waist is 1 size larger than hip → recommend waist size
    if (diff === 1) {
      return {
        size: SIZE_CHART[waistIdx].size,
        confidence: 'high',
        note: 'Your hips measure smaller than the waist, so the Saree Silhouette may be a little loose at your hips.',
        betweenSizes: false
      };
    }

    // Case 3: Hip is 1 size larger than waist → recommend hip size
    if (diff === -1) {
      return {
        size: SIZE_CHART[hipIdx].size,
        confidence: 'high',
        note: 'Your waist measures smaller than the hips. We suggest using the drawstring to adjust the waist for a perfect fit.',
        betweenSizes: false
      };
    }

    // Case 4 & 5: 2+ sizes apart → between sizes, show popup
    return {
      size: null,
      confidence: 'low',
      note: null,
      betweenSizes: true
    };
  }

  // =============================================
  // RESULT DISPLAY
  // =============================================

  function showResult() {
    var heightInfo = HEIGHT_MAP[state.heightKey];
    var sizeResult = computeSize(state.waist, state.hip);

    // Hide steps and progress
    steps.forEach(function (s) { s.classList.remove('is-active'); });
    quiz.querySelector('.size-quiz__progress').style.display = 'none';

    // Between sizes — show popup instead of result
    if (sizeResult.betweenSizes) {
      showBetweenSizesPopup();
      return;
    }

    // Populate badges
    resultEl.querySelector('[data-result="size"]').textContent = sizeResult.size;
    resultEl.querySelector('[data-result="length"]').textContent = heightInfo.length + '"';

    // Populate text
    resultEl.querySelector('[data-result="size-text"]').textContent = sizeResult.size;
    resultEl.querySelector('[data-result="length-text"]').textContent =
      heightInfo.length + '" ' + heightInfo.label;

    // Confidence indicator
    var confEl = resultEl.querySelector('.size-quiz__confidence');
    confEl.dataset.confidence = sizeResult.confidence;
    confEl.querySelector('.size-quiz__confidence-text').textContent = 'High confidence match';

    // Sizing note (case 2 or 3)
    var noteEl = resultEl.querySelector('.size-quiz__result-note');
    if (sizeResult.note) {
      noteEl.textContent = sizeResult.note;
      noteEl.style.display = 'block';
    } else {
      noteEl.style.display = 'none';
    }

    // CTA URL
    var cta = resultEl.querySelector('.size-quiz__result-cta');
    cta.href = heightInfo.collection + '?filter.v.option.size=' + encodeURIComponent(sizeResult.size);
    cta.textContent = 'Shop ' + sizeResult.size + ' in ' + heightInfo.length + '" ' + heightInfo.label + ' \u2192';

    // Show result
    resultEl.classList.add('is-active');
    quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // =============================================
  // BETWEEN-SIZES POPUP (uses embedded Shopify contact form)
  // =============================================

  var betweenPopup = null;

  function showBetweenSizesPopup() {
    if (!betweenPopup) {
      betweenPopup = document.createElement('div');
      betweenPopup.className = 'sz-popup';
      betweenPopup.setAttribute('role', 'dialog');
      betweenPopup.setAttribute('aria-modal', 'true');
      betweenPopup.setAttribute('aria-label', 'Between sizes');
      betweenPopup.innerHTML =
        '<div class="sz-popup__backdrop"></div>' +
        '<div class="sz-popup__panel">' +
          '<button type="button" class="sz-popup__close" aria-label="Close">&times;</button>' +
          '<div class="sz-popup__step sz-popup__step--ask is-active">' +
            '<h3 class="sz-popup__title">You appear to be between sizes</h3>' +
            '<p class="sz-popup__desc">Would you like our team to reach out with a personalized size recommendation?</p>' +
            '<div class="sz-popup__actions">' +
              '<button type="button" class="sz-popup__btn sz-popup__btn--yes">Yes, please</button>' +
              '<button type="button" class="sz-popup__btn sz-popup__btn--no">No, thanks</button>' +
            '</div>' +
          '</div>' +
          '<div class="sz-popup__step sz-popup__step--form">' +
            '<h3 class="sz-popup__title">Get a personalized recommendation</h3>' +
            '<p class="sz-popup__desc">Enter your email and our team will get back to you with sizing advice.</p>' +
            '<div class="sz-popup__form-slot"></div>' +
          '</div>' +
          '<div class="sz-popup__step sz-popup__step--thanks">' +
            '<h3 class="sz-popup__title">Thank you!</h3>' +
            '<p class="sz-popup__desc">Our team will be in touch shortly with a personalized recommendation.</p>' +
            '<button type="button" class="sz-popup__btn sz-popup__btn--done">Close</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(betweenPopup);

      // Move the real Shopify contact form into the popup
      var formWrap = document.getElementById('sz-contact-form-wrap');
      if (formWrap) {
        var formSlot = betweenPopup.querySelector('.sz-popup__form-slot');
        formSlot.appendChild(formWrap);
        formWrap.style.display = '';
      }

      // Events
      betweenPopup.querySelector('.sz-popup__backdrop').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__close').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__btn--no').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__btn--done').addEventListener('click', closeBetweenPopup);
      betweenPopup.querySelector('.sz-popup__btn--yes').addEventListener('click', function () {
        betweenPopup.querySelector('.sz-popup__step--ask').classList.remove('is-active');
        betweenPopup.querySelector('.sz-popup__step--form').classList.add('is-active');
        // Set the body field with measurement details
        var bodyField = document.getElementById('sz-contact-body');
        if (bodyField) {
          bodyField.value =
            'I took the size quiz and my measurements are between sizes.\n' +
            'Waist: ' + state.waist + ' in\n' +
            'Hip: ' + state.hip + ' in\n\n' +
            'Please help me find the right size.';
        }
        var emailInput = formWrap ? formWrap.querySelector('input[type="email"]') : null;
        if (emailInput) emailInput.focus();
      });

      // Intercept form submit: use fetch with the form's own data (includes CSRF token)
      var realForm = formWrap ? formWrap.querySelector('form') : null;
      if (realForm) {
        realForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var formData = new FormData(realForm);
          var submitBtn = realForm.querySelector('button[type="submit"]');
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

          fetch(realForm.action, {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'text/html' }
          })
          .then(function (res) {
            console.log('[SizeQuiz] POST status:', res.status);
            betweenPopup.querySelector('.sz-popup__step--form').classList.remove('is-active');
            betweenPopup.querySelector('.sz-popup__step--thanks').classList.add('is-active');
          })
          .catch(function (err) {
            console.error('[SizeQuiz] submit error:', err);
            betweenPopup.querySelector('.sz-popup__step--form').classList.remove('is-active');
            betweenPopup.querySelector('.sz-popup__step--thanks').classList.add('is-active');
          })
          .finally(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
          });
        });
      }

      betweenPopup.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeBetweenPopup();
      });
    }

    // Reset to first step
    betweenPopup.querySelectorAll('.sz-popup__step').forEach(function (s) { s.classList.remove('is-active'); });
    betweenPopup.querySelector('.sz-popup__step--ask').classList.add('is-active');
    var emailInput = betweenPopup.querySelector('#sz-contact-form-wrap input[type="email"]');
    if (emailInput) emailInput.value = '';
    betweenPopup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeBetweenPopup() {
    if (betweenPopup) {
      betweenPopup.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    // Go back to step 2 so user can adjust measurements
    goToStep(2);
  }

  // =============================================
  // NAVIGATION
  // =============================================

  function goToStep(step) {
    state.currentStep = step;

    steps.forEach(function (s) { s.classList.remove('is-active'); });
    resultEl.classList.remove('is-active');
    quiz.querySelector('.size-quiz__progress').style.display = '';

    var target = quiz.querySelector('[data-step="' + step + '"]');
    if (target) target.classList.add('is-active');

    progressSteps.forEach(function (bar, i) {
      bar.classList.remove('is-active', 'is-complete');
      if (i + 1 < step) bar.classList.add('is-complete');
      if (i + 1 === step) bar.classList.add('is-active');
    });

    if (progressLabel) progressLabel.textContent = 'Step ' + step + ' of 2';

    if (step === 2 && waistInput) {
      setTimeout(function () { waistInput.focus(); }, 300);
    }

    quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function goBack() {
    if (state.currentStep > 1) {
      goToStep(state.currentStep - 1);
    }
  }

  function retake() {
    state = { currentStep: 1, heightKey: null, unit: 'in', waist: null, hip: null };

    waistInput.value = '';
    hipInput.value = '';
    waistInput.placeholder = 'e.g. 32';
    hipInput.placeholder = 'e.g. 38';
    nextBtn.disabled = true;

    unitBtns.forEach(function (btn) {
      var isInches = btn.dataset.unit === 'in';
      btn.classList.toggle('is-active', isInches);
    });
    unitDisplays.forEach(function (span) { span.textContent = 'in'; });

    if (validationEl) {
      validationEl.textContent = '';
      validationEl.style.display = 'none';
    }

    quiz.querySelectorAll('[data-step="1"] .size-quiz__option').forEach(function (o) {
      o.classList.remove('is-selected');
    });

    goToStep(1);
  }

  // =============================================
  // BOOTSTRAP
  // =============================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
